import React, { useState, useRef } from 'react';
import EditableImage from 'global/components/EditableImage/index';
import {ExtenderClass, TITLE, SUBTITLE, INVALID_CLASS_CHECK} from "./helperClasses";
import LayoutBuilder from 'LayoutBuilder';
import SlideInRight from 'global/components/SlideInRight/index';


const {Container, Row, Column} = LayoutBuilder;

class EditableImages extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      images: this.props.value ? (Array.isArray(this.props.value) ? this.props.value : [this.props.value]) : []
    }
    //this.extraCheck = (newValue)=>{return((!newValue || !newValue.name || !newValue.url) ? false : true)}
    this.extraCheck = (newValue)=>{
      return((!newValue || newValue.length === 0) ? false : true)
    }
    this.Validate = this.Validate.bind(this);
  }

  componentDidMount(){
    this.Validate(this.props.value);
  }


  Validate(newValue){
    var {field={}} = this.props;
    var {required, name=""} = field;
    if(!required){
      this.props.onChangeValid(name, true);
      return;
    }

    var valid = true;
    if(!newValue) valid = false;
    if(valid && this.extraCheck) valid = this.extraCheck(newValue)
    this.props.onChangeValid(name, valid);
  }

  onUpdateImage = (shouldSave)=>{
    if(shouldSave) {
      var {imageIndex=[], editImageMeta={}} = this.state;    
      this.props.field.onChangeImage(imageIndex, editImageMeta)
    }
    this.setState({
      imageIndex: undefined,
      editImageMeta: undefined
    })
  }

  render(){
    var {images=[], editImageMeta} = this.state;          
    var {field={}, id, value="", onTouch, meta} = this.props;
    var {name="", required, title, options=[], maxNumber=1, maxWidth, placeHolderImage, filePath, colSettings={
      col:12,
      xs:12,
      sm:12,
      md:6,
      lg:6,
      xl:4,
      style:{},
      placeHolderImage: undefined
    }} = field;
    var imageDiv = {...STYLES.imageDiv, ...(maxWidth ? {"maxWidth": maxWidth, "minWidth": maxWidth} : {})};
    return(
      <div className={`imageUpload ${INVALID_CLASS_CHECK(meta, field.required, "error", "")}`}>
        {TITLE(field.title, field.required, field.requiredMessage)}
        {SUBTITLE(field.subTitle)}
        <Row className="">
          {
            images.map((imageObj={}, index)=>{
              return(
                <Column className="" {...colSettings} key={index}>
                  <EditableImage
                    placeHolderImage={placeHolderImage}
                    images={[imageObj]}
                    filePath={filePath}
                    onChangeImage={(newImageObj, callBack)=>{
                      this.props.field.onChangeImage(index, newImageObj);
                      callBack();
                    }}
                    CustomButton={
                      <div className="edit customButton" onClick={()=>{this.setState({editImageMeta: imageObj, imageIndex: index})}}>
                        <i className="fas fa-pen" title="Edit Alt"></i>
                      </div>
                    }
                    showDeleteButton={true}
                  />
                  <br/>
                </Column>
              )
            })
          }
          {
            (images.length < Number(maxNumber)) &&
            <Column className="" {...colSettings}>
              <EditableImage
                placeHolderImage={placeHolderImage}
                images={[]}
                filePath={filePath}
                onChangeImage={(newImageObj, callBack)=>{
                  this.props.field.onChangeImage(images.length, newImageObj);
                  callBack();
                }}
                showDeleteButton={false}
              />
              <div className="underLay"></div>
              <br/>
            </Column>
          }
        </Row>  
        {
          editImageMeta &&
          <SlideInRight 
            showOverlay={true}
            width="1000px"
            maxWidth="90%"
            header={<div className="title">Edit Image Alt Meta Info</div>}
            footer={<div className="buttonGroup">
              <button className="button button2" onClick={()=>this.onUpdateImage(false)}>Cancel</button>
              <button className="button button1" onClick={()=>this.onUpdateImage(true)}>Save</button>
            </div>}
            onClose={()=>this.onUpdateImage(true)}>
            <EditAltMeta
              imageObj={editImageMeta}
              onChangeImage={newObj=>{
                this.setState({editImageMeta: newObj})
              }}
            />
          </SlideInRight>
        }
        {INVALID_CLASS_CHECK(meta, field.required, (field.errorMessage && <small className="form-text red-text errorMessage">{field.errorMessage}</small>), null)}
      </div>
    )
  }
}


const EditAltMeta = props => {
  const { onChangeImage, imageObj } = props;    
  if(!imageObj) return null;
  //console.log("imageObj", imageObj)
  return (
    <div className="editAltImageMeta" style={{"padding":"20px"}}>
      <form 
        action="" 
        className="FormBuilder" 
        onSubmit={(e)=>{
          e.preventDefault();
        }} >
        <div id="ImageBox">
          <img style={{"maxWidth":"500px"}} src={imageObj.url}/>
        </div>
        <div className="form-group">
          <div>
            <div className="input-header">
              <div className="formTitle">
                <span className="">Edit Image SEO Alt Tag</span>
              </div>
            </div>
            <div className="input-header-sub">
              <div className="formSubTitle">
                <span className="">This is used for SEO reasons and if you add something the image assosiated with it will have that SEO info.</span>
              </div>
            </div>
            <textarea 
              type="text" 
              className={`form-control`}  
              value={imageObj.alt}
              name={"alt"}
              rows={10}
              columns={1}
              onChange={e=>{
                e.preventDefault()
                var newVal = e.target.value;
                imageObj.alt = newVal;
                onChangeImage(imageObj);
              }}
            />
          </div>
        </div>
        <div className="form-group">
          <div>
            <div className="input-header">
              <div className="formTitle">
                <span className="">Edit Image Name</span>
              </div>
            </div>
            <div className="input-header-sub">
              <div className="formSubTitle">
                <span className="">If you want to change the image name, do so here. But this won't change the URL, just the short name.</span>
              </div>
            </div>
            <input 
              type="text" 
              className={`form-control`}  
              value={imageObj.name}
              name={"name"}
              onChange={e=>{
                e.preventDefault()
                var newVal = e.target.value;
                imageObj.name = newVal;
                onChangeImage(imageObj);
              }}
            />
          </div>
        </div>
        <div className="form-group">
          <div>
            <div className="input-header">
              <div className="formTitle">
                <span className="">Edit Image Order</span>
              </div>
            </div>
            <div className="input-header-sub">
              <div className="formSubTitle">
                <span className="">If you want to manualy change the order number, you can do it here...I guess.</span>
              </div>
            </div>
            <input 
              type="number" 
              className={`form-control`}  
              value={imageObj.order}
              name={"order"}
              onChange={e=>{
                e.preventDefault()
                var newVal = e.target.value;
                imageObj.order = newVal;
                onChangeImage(imageObj);
              }}
            />
          </div>
        </div>
      </form>
    </div>
  )
}

const STYLES = {
  image:{
    "maxWidth": "100%",
    "cursor": "pointer"
  },
  dropZone: {
    "position":'relative',
    "pointerEvents": "none"
  },
  dropZoneText: {
    "position": "absolute",
    "inset": "0px",
    "background": "hsl(199 98% 48% / .5)",
    "display": "flex",
    "alignItems": "center",
    "justifyContent": "center",
    "color": "white",
    "fontSize": "20px",
    "pointerEvents": "none"
  },
  imageWrapper: {
    "display": "flex", 
    "alignItems": "center", 
    "margin": "0 -1%",
    "flexWrap": "wrap"
  },
  tempStyles: {
    "height": "auto",
    "display": "block",
    "padding": "15px 10px",
    "margin": "0 0 15px 0",
    "borderColor": "#ddd"
  },
  imageDiv: {
    "maxWidth":"100%",
    "minWidth":"100%",
    "border":"1px solid #ddd",
    "margin":"0 1% 30px",
    "position":"relative",
  },
  deleteDiv: {
    "background": "red",
    "width": "30px",
    "height": "30px",
    "display": "flex",
    "alignItems": "center",
    "justifyContent": "center",
    "position": "absolute",
    "right": "0px",
    "top": "0px",
    "cursor": "pointer"
  },
  deleteIcon: {
    "color": "#FFF"
  }
}

export default EditableImages;